module.exports = __webpack_public_path__ + "static/media/Pluxee_Logo_White_RGB.c5a6f6db.png";